
import { getUserData } from "../../api/auth/get";
import { getModelsData } from "../../api/models/get";
import { getActivities, getAllClientsData, getAllPhonesData, getDashboardStat, getExpenses, getGeneralDashboardStat, getPhonesData, getReports, getStaffUsers, getStores, allGeneralSalesData, getGeneralClientsSummary, getGeneralReports } from "../../api/products/get";
import { getStockSummary } from "../../api/products/post";
import { getSuppliersData } from "../../api/suppliers/get";
import TYPES from "../types";

export const userData: any = (cb: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getUserData()
            .then((data: any) => {
                dispatch({
                    type: TYPES.USER_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const modelsData: any = (storeId: any, page: any, limit: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getModelsData(storeId, page, limit)
            .then((data: any) => {
                dispatch({
                    type: TYPES.MODELS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const suppliersData: any = (storeId: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getSuppliersData(storeId)
            .then((data: any) => {
                dispatch({
                    type: TYPES.SUPPLIERS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const phonesData: any = (storeId: any, page: any, limit: any, modelId: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getPhonesData(storeId, page, limit, modelId)
            .then((data: any) => {
                dispatch({
                    type: TYPES.PHONES_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allPhonesData: any = (storeId: any, status: any, page: any, limit: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getAllPhonesData(storeId, status, page, limit)
            .then((data: any) => {
                dispatch({
                    type: TYPES.ALL_PHONES_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allGeneralSales: any = (storeId: any, page: any, limit: any, params: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        allGeneralSalesData(storeId, page, limit, params)
            .then((data: any) => {
                dispatch({
                    type: TYPES.ALL_GENERAL_SALES_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allGeneralClientsData: any = (storeId: any, page: any, limit: any, onlyDebtors: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getGeneralClientsSummary(storeId, page, limit, onlyDebtors)
            .then((data: any) => {
                dispatch({
                    type: TYPES.ALL_GENERAL_CLIENTS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allClientsData: any = (storeId: any, page: any, limit: any, onlyDebtors: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getAllClientsData(storeId, page, limit, onlyDebtors)
            .then((data: any) => {
                dispatch({
                    type: TYPES.ALL_CLIENTS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allExpensesData: any = (storeId: any, page: any, limit: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getExpenses(storeId, page, limit)
            .then((data: any) => {
                dispatch({
                    type: TYPES.ALL_EXPENSES_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const reportsData: any = (storeId: any, payload: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getReports(storeId, payload)
            .then((data: any) => {
                dispatch({
                    type: TYPES.REPORTS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const generalReportsData: any = (storeId: any, payload: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getGeneralReports(storeId, payload)
            .then((data: any) => {
                dispatch({
                    type: TYPES.GENERAL_REPORTS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const allStaffUsersData: any = (storeId: any, page: any, limit: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getStaffUsers(storeId, page, limit)
            .then((data: any) => {
                dispatch({
                    type: TYPES.STAFF_USERS_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

let storesRequestId = 0;

export const allStoresData: any = () => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        const requestId = ++storesRequestId;
        const token = localStorage.getItem('token');
        const isCurrentRequest = () => requestId === storesRequestId && token === localStorage.getItem('token');
        dispatch({ type: TYPES.ALL_STORES_LOADING, payload: null });
        try {
            const data = await getStores();
            if (!Array.isArray(data)) throw new Error('Invalid store list');
            // A late response must not replace a newer list or another account's boutiques.
            if (!isCurrentRequest()) return;
            dispatch({ type: TYPES.ALL_STORES_DATA, payload: data });
            return data;
        } catch {
            if (isCurrentRequest()) {
                dispatch({ type: TYPES.ALL_STORES_ERROR, payload: 'Impossible de charger vos boutiques.' });
            }
        }
    };
};

export const getActivitiesData: any = (storeId: any, page: any, limit: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getActivities(storeId, page, limit)
            .then((data: any) => {
                dispatch({
                    type: TYPES.LOGS_ACTIVITIES_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const getDashboardStatData: any = (storeId: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getDashboardStat(storeId)
            .then((data: any) => {
                dispatch({
                    type: TYPES.DASHBOARD_STAT_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

export const getGeneralDashboardStatData: any = (storeId: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getGeneralDashboardStat(storeId)
            .then((data: any) => {
                dispatch({
                    type: TYPES.GENERAL_DASHBOARD_STAT_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};


export const stockSummaryData: any = (storeId: any, params: any) => {
    return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
        getStockSummary(storeId, params)
            .then((data: any) => {
                dispatch({
                    type: TYPES.STOCK_SUMMARY_DATA,
                    payload: data,
                });
            })
            .catch((error: any) => {
            });
    };
};

// export const switchStore: any = (storeId: any) => {
//     return async (dispatch: (arg0: { type: any; payload: any; }) => void) => {
//         getDashboardStat(storeId)
//             .then((data: any) => {
//                 dispatch({
//                     type: TYPES.DASHBOARD_STAT_DATA,
//                     payload: data,
//                 });
//             })
//             .catch((error: any) => {
//             });
//     };
// };
